/* =========================================================
   AIELLO Header — interactions
   - Mega menu: hover (desktop) / click (mobile)
   - Dropdowns: hover (desktop)
   - Mobile drawer + accordion
   - ESC fecha tudo
   ========================================================= */

(function () {
  'use strict';

  function init(header) {
    if (!header || header.__aielloInit) return;
    header.__aielloInit = true;

    var triggers = header.querySelectorAll('[data-aiello-hd-trigger]');
    var targets = {};
    header.querySelectorAll('[data-aiello-hd-target]').forEach(function (el) {
      targets[el.getAttribute('data-aiello-hd-target')] = el;
    });

    var navItems = header.querySelectorAll('[data-aiello-hd-nav-item]');
    var openDelay, closeDelay;
    var currentOpen = null;

    function isDesktop() { return window.matchMedia('(min-width: 1024px)').matches; }

    function openTarget(key) {
      Object.keys(targets).forEach(function (k) {
        if (k !== key) {
          targets[k].classList.remove('is-open');
          targets[k].setAttribute('aria-hidden', 'true');
        }
      });
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', t.getAttribute('data-aiello-hd-trigger') === key ? 'true' : 'false');
      });
      if (targets[key]) {
        targets[key].classList.add('is-open');
        targets[key].setAttribute('aria-hidden', 'false');
        currentOpen = key;
      }
    }
    function closeAll() {
      Object.keys(targets).forEach(function (k) {
        targets[k].classList.remove('is-open');
        targets[k].setAttribute('aria-hidden', 'true');
      });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      currentOpen = null;
    }

    /* === Desktop hover === */
    navItems.forEach(function (item) {
      var key = item.getAttribute('data-aiello-hd-nav-item');
      if (!targets[key]) return;

      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeDelay);
        openDelay = setTimeout(function () { openTarget(key); }, 80);
      });
      item.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        clearTimeout(openDelay);
        closeDelay = setTimeout(closeAll, 200);
      });
    });

    /* === Manter mega/dropdown aberto ao entrar nele === */
    Object.keys(targets).forEach(function (key) {
      targets[key].addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeDelay);
      });
      targets[key].addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        closeDelay = setTimeout(closeAll, 200);
      });
    });

    /* === Click no trigger (mobile/tablet, ou se quiser fechar/abrir manualmente) === */
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        var key = trigger.getAttribute('data-aiello-hd-trigger');
        // Se for desktop e o target ja esta aberto, deixa o link funcionar normal
        if (isDesktop() && currentOpen === key) {
          // navega
          return;
        }
        // Se for mobile, prevenir e abrir
        if (!isDesktop()) {
          e.preventDefault();
        }
        if (currentOpen === key) {
          closeAll();
        } else {
          openTarget(key);
        }
      });
    });

    /* === ESC fecha === */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll();
        closeDrawer();
      }
    });

    /* === Click fora fecha === */
    document.addEventListener('click', function (e) {
      if (!currentOpen) return;
      if (!header.contains(e.target)) closeAll();
    });

    /* === Drawer mobile === */
    var burger = header.querySelector('[data-aiello-hd-burger]');
    var drawer = header.querySelector('[data-aiello-hd-drawer]');
    var overlay = header.querySelector('[data-aiello-hd-overlay]');
    var closeBtn = header.querySelector('[data-aiello-hd-close]');

    function openDrawer() {
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    /* === Acordeao no drawer === */
    header.querySelectorAll('[data-aiello-hd-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var content = btn.nextElementSibling;
        if (!content) return;
        var isOpen = content.classList.contains('is-open');
        if (isOpen) {
          content.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          content.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function bootstrap() {
    document.querySelectorAll('.aiello-hd').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
